import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { kickPlayerOfflineLogList } from "@/api/gmToolNew/gmToolNew";
import addKickPlayer from "./components/addKickPlayer.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "serverManagement",
  components: {
    addKickPlayer: addKickPlayer
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      total: 0,
      list: [],
      paramsData: {
        page: 1,
        reason: '',
        is_mode: 1
      },
      date: [],
      reasonList: [{
        label: this.$t('otherClientLogin'),
        value: 1
      }, {
        label: this.$t('accountBlacklist'),
        value: 2
      }, {
        label: this.$t('clientUpdateResource'),
        value: 3
      }, {
        label: this.$t('serverMaintenance'),
        value: 4
      }],
      reasonMap: {
        "1": this.$t('otherClientLogin'),
        "2": this.$t('accountBlacklist'),
        "3": this.$t('clientUpdateResource'),
        "4": this.$t('serverMaintenance')
      },
      nameList: [{
        label: this.$t('open'),
        value: 1
      }, {
        label: this.$t('close'),
        value: 2
      }]
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.paramsData.page = val;
      this.getList();
    },
    getList: function getList(e) {
      var _this = this;

      this.paramsData.page = e;
      this.paramsData.start_time = this.date && this.date[0] ? this.$times.timestampToTime(this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.paramsData.end_time = this.date && this.date[1] ? this.$times.timestampToTime(this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.reqLoading = true;
      kickPlayerOfflineLogList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data || [];

          _this.tableData.forEach(function (item) {
            var foundData = _this.serverListYJ.find(function (b) {
              return b.serverID == item.server_id;
            });

            item.serverName = foundData ? foundData.serverName : '/';
            item.reasonName = _this.reasonMap[item.reason];
          });

          _this.total = res.data.total ? parseInt(res.data.total) : 0;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.SelectionList = e;
    },
    modifyData: function modifyData() {
      var idList = [];
      this.serverListYJ.forEach(function (item) {
        idList.push({
          "server_name": item.serverName,
          "server_id": item.serverID
        });
      });
      this.$refs.modifyBatchServer.open(JSON.stringify(idList));
    }
  }
};